import React, {useEffect, useState} from 'react';
import _ from "lodash";
import {PlusIcon, XMarkIcon} from "@heroicons/react/24/solid";
import {prepareTextListForSearch} from "../common/utils/text-util";
import {addSingleTag, getSingleTag} from "../common/services/tag-data-service";

const SelectTags = ({
                        allTags,
                        existingTags,
                        handleSelectTagsChanges,
                        showAddTag,
                        showClearSelectedTags,
                        showClearSelectedTagsIcon
                    }) => {
    const [searchText, setSearchText] = useState('');
    const [filteredTagsList, setFilteredTagsList] = useState(allTags);
    const [selectedTags, setSelectedTags] = useState([]);

    useEffect(() => {
        setSelectedTags(existingTags);
        prepareFilteredTagsList();
    }, [existingTags]);

    const toggleTagSelection = (tagItem) => {
        tagItem.selected = !tagItem.selected;

        let existingSelectedTags = []

        if (!_.isEmpty(selectedTags)) {
            existingSelectedTags = [...selectedTags];
        }

        if (existingSelectedTags.indexOf(tagItem.id) === -1) {
            existingSelectedTags.push(tagItem.id);
        } else {
            existingSelectedTags = _.filter(existingSelectedTags, (existingTag) => {
                return existingTag !== tagItem.id;
            });
        }

        const event = {
            target: {
                name: 'tagList',
                value: existingSelectedTags
            }
        };

        setSelectedTags(existingSelectedTags);
        handleSelectTagsChanges(event);
        clearFiltersAfterSelection();
    }

    const clearFiltersAfterSelection = () => {
        const existingFilteredTagsList = [...filteredTagsList];

        if (existingFilteredTagsList.length <= 1 && searchText) {
            setSearchText('');
        }
    }

    const handleClearSearch = () => {
        setSearchText('');
    }

    const handleSearchText = (event) => {
        setSearchText(_.toLower(event.target.value));
    }

    const clearSelectedTags = () => {
        const tempSelectedTags = [];
        const event = {
            target: {
                name: 'tagList',
                value: tempSelectedTags
            }
        };

        setSelectedTags(tempSelectedTags);
        handleSelectTagsChanges(event);
        prepareFilteredTagsList();
    }

    const addNewTag = async () => {
        const text = searchText;
        let changedText = _.startCase(text);
        let textList = prepareTextListForSearch(text);

        const newTag = {
            text: text,
            textList: textList,
            startText: changedText,
            displayText: changedText,
        }

        addSingleTag(newTag)
            .then(async (response: any) => {
                const addedTagId = response.id;
                const addedTagDetail: any = await getSingleTag(addedTagId);
                const addedTag = addedTagDetail.data();
                addedTag.id = addedTagId;

                allTags.push(addedTag);
                toggleTagSelection(addedTag);
                // prepareFilteredTagsList();
            })
            .catch(error => {
                console.log('addSingleTag() Error: ', error);
            });
    }

    useEffect(() => {
        prepareFilteredTagsList();
    }, [searchText]);

    const prepareFilteredTagsList = () => {
        let existingSelectedTags = existingTags || [];

        const updatedFilteredTagsList = searchText ? [] : allTags;

        _.forEach(allTags, tag => {
            tag.selected = existingSelectedTags.indexOf(tag.id) !== -1;

            if (tag.textList.indexOf(searchText) !== -1) {
                updatedFilteredTagsList.push(tag);
            }
        });

        setFilteredTagsList(_.orderBy(updatedFilteredTagsList, ['selected', 'startText'], ['desc', 'asc']));
    }

    return (
        <>
            <div className="flex justify-start w-full sticky top-0 bg-blue-100 border-b border-blue-400">
                <div className="field-group-container">

                    <div className="field-container">
                        {/*<div className="field-label">
                            Search Tags
                        </div>*/}
                        <input
                            placeholder="Search Tags"
                            type="text"
                            className="input-field-medium"
                            id="searchText"
                            name="searchText"
                            value={searchText}
                            onChange={handleSearchText}>
                        </input>
                    </div>

                    {searchText &&

                        <button
                            onClick={() => handleClearSearch()}
                            className="rounded -ml-11 flex items-center justify-center border-gray-500 bg-white text-gray-500 hover:bg-gray-500 hover:text-white">
                            <div className="p-1">
                                <XMarkIcon className="h-6 w-6"/>
                            </div>
                        </button>
                    }

                    {searchText && filteredTagsList?.length === 0 && showAddTag &&

                        <button
                            onClick={() => addNewTag()}
                            className="rounded ml-4 px-4 py-2 flex items-center justify-center border bg-gray-500 text-white hover:border-gray-500 hover:text-gray-500 hover:bg-white">
                            Add New Tag
                        </button>
                    }

                    {(showClearSelectedTags || showClearSelectedTagsIcon) && !searchText &&
                        <button
                            onClick={() => clearSelectedTags()}
                            className="rounded ml-2 flex items-center justify-center border bg-red-100 text-red-500 border-red-500 hover:text-gray-700 hover:bg-white hover:border-gray-500">
                            {!showClearSelectedTagsIcon &&
                                <span className="py-2 px-4">Clear Selected Tags</span>
                            }
                            {showClearSelectedTagsIcon &&
                                <div className="p-1">
                                    <XMarkIcon className="h-6 w-6"/>
                                </div>
                            }
                        </button>
                    }

                </div>
            </div>

            <div className="flex flex-wrap m-2">
                {filteredTagsList?.map((tagItem, index) => (
                    <div key={index}>

                        {tagItem.selected &&
                            <button type="button"
                                    onClick={() => {
                                        toggleTagSelection(tagItem)
                                    }}
                                    className="m-1 inline-block py-1 px-2 bg-blue-600 text-sm text-white font-medium leading-tight rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out">
                                {tagItem?.startText}
                            </button>
                        }

                        {!tagItem.selected &&
                            <button type="button"
                                    onClick={() => {
                                        toggleTagSelection(tagItem)
                                    }}
                                    className="m-1 inline-block py-1 px-2 border border-gray-600 text-sm text-gray-600 font-medium leading-tight rounded hover:bg-black hover:bg-opacity-5 focus:outline-none focus:ring-0 transition duration-150 ease-in-out">
                                {tagItem?.startText}
                            </button>
                        }

                    </div>
                ))}
            </div>
        </>
    )
}

export default SelectTags
